import $ from 'jquery';
import StorageUtils from 'chairisher/util/storage';

/**
 * A JS component that represents a menu drawer whose visibility can be toggled and can contain menus
 *
 * @param {Object} settings
 * @param {jQuery} settings.$el The jQuery element representing the MenuDrawer
 * @param {string=} settings.storageKey Optional key to use when storing this component's data in local storage
 */
class MenuDrawer {
    constructor({ $el = null, storageKey = null }) {
        this.$el = $el ?? $('<div></div>', { class: 'horizontal-menu-drawer js-menu-drawer' });
        this.storageKey = storageKey;

        if (this.storageKey) {
            this.updateFromLocalStorage();
        }
    }

    /**
     * Attaches the MenuDrawer to the DOM
     */
    attach() {
        this.$el.appendTo($(document.body));
    }

    /**
     * Removes the MenuDrawer from the DOM and nulls it out
     */
    destroy() {
        this.$el.remove();
        this.$el = null;
    }

    /**
     * @returns {jQuery} The jQuery object representing the MenuDrawer
     */
    getEl() {
        return this.$el;
    }

    /**
     * Hides the MenuDrawer
     */
    hide() {
        this.toggle(false);
    }

    /**
     * @returns {boolean} True indicates the MenuDrawer is visible
     */
    isVisible() {
        return this.$el.hasClass('visible');
    }

    /**
     * Persists the current selections in local storage
     */
    persistLocally() {
        if (this.storageKey) {
            StorageUtils.setItem(
                this.storageKey,
                JSON.stringify({
                    isVisible: this.isVisible(),
                }),
            );
        }
    }

    /**
     * Shows the MenuDrawer
     */
    show() {
        this.$el.removeClass('hidden');
        this.toggle(true);
    }

    /**
     * Updates the selected choices with those currently stored in local storage
     */
    updateFromLocalStorage() {
        if (this.storageKey) {
            const valJson = StorageUtils.getItem(this.storageKey);
            if (valJson) {
                const val = JSON.parse(valJson);
                this.toggle(val.isVisible);
            }
        }
    }

    /**
     * Toggles the MenuDrawer's visibility
     */
    toggle(shouldDisplay) {
        this.$el.toggleClass('visible', shouldDisplay);
        this.persistLocally();
    }
}

export default MenuDrawer;
